import styled from "@emotion/styled";

import { Container as TopicSearchResultListContainer } from "scmp-app/components/search/search-result-panel/search-result-list/topic-search-result-list/styles";

import { SectionSearchResultListItem } from "./section-search-result-list-item";

export const StyledSectionSearchResultListItem = styled(SectionSearchResultListItem)``;

export const Container = styled.div`
  padding-block: 20px;

  border-block: 1px solid rgba(0, 0, 0, 0.2);

  ${StyledSectionSearchResultListItem}:not(:last-child) {
    margin-block-end: 20px;
  }

  & + ${TopicSearchResultListContainer} {
    border-block-start: none;
  }
`;

export const SectionSectionTitle = styled.p`
  margin-block-end: 4px;

  font-size: 14px;
`;
